// ============================================================================
// patientCabinetRenderer.tsx — ПРИЛОЖЕНИЕ «Мой кабинет» (appKind/code
// 'patient_cabinet'): точка входа КАБИНЕТА ПАЦИЕНТА в оболочке «Предприятие».
//
// Рендерер регистрируется КЛИЕНТОМ (реестр приложений): кабинет открывается из
// дока/«Пуска» для системной роли «Пациент» (useVisibleApps) без серверного
// объекта kind='app' — код резолвится getAppRendererByCode, манифест лишь
// уточняет имя/область. Серверный объект приложения может быть создан позже —
// рендерер менять не придётся.
// ============================================================================

import { registerAppRenderer, type AppManifest, APPSDK_VERSION } from '@/lib/apps/sdk';
import { PatientCabinetPage } from '@/pages/PatientCabinetPage';
import { PATIENT_CABINET_APP_CODE, PATIENT_ROLE } from '@/lib/patientCabinet';
import { useSecurityAccess } from '@/lib/securityRoles';
import { useI18n } from '@/lib/i18n/I18nProvider';

function PatientCabinetApp() {
    const { t } = useI18n();
    const access = useSecurityAccess();
    const allowed = access.isAdmin || access.roles.includes(PATIENT_ROLE);
    if (!allowed) {
        return (
            <div className="h-full flex items-center justify-center p-6">
                <div className="max-w-md text-center space-y-2">
                    <div className="text-sm font-medium">{t('psy.cabinet_unavailable')}</div>
                    <div className="text-xs text-muted-foreground">
                        {t('psy.cabinet_unavailable_hint')}
                    </div>
                </div>
            </div>
        );
    }
    return <PatientCabinetPage />;
}

/** Манифест приложения кабинета (AppHost): системное, на весь воркспейс. */
export const PATIENT_CABINET_MANIFEST: AppManifest = {
    code: PATIENT_CABINET_APP_CODE,
    name: PATIENT_CABINET_APP_CODE,
    synonym: 'Мой кабинет',
    appKind: PATIENT_CABINET_APP_CODE,
    area: 'full',
    apiVersion: APPSDK_VERSION,
    // Кабинет содержит вкладку «Запись» (запись/перенос/отмена в рамках прав).
    permissions: ['data:read', 'data:write'],
};

export function registerPatientCabinetApp(): void {
    registerAppRenderer({
        appKind: PATIENT_CABINET_APP_CODE,
        code: PATIENT_CABINET_APP_CODE,
        title: 'Мой кабинет',
        Component: PatientCabinetApp,
        manifest: PATIENT_CABINET_MANIFEST,
    });
}
